var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    width: 18.047,
    height: 14.663,
    viewBox: "0 0 18.047 14.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-list-ul",
    "data-name": "Icon awesome-list-ul",
    d: "M1.692,3.375A1.692,1.692,0,1,0,3.384,5.067,1.692,1.692,0,0,0,1.692,3.375Zm0,5.64a1.692,1.692,0,1,0,1.692,1.692A1.692,1.692,0,0,0,1.692,9.015Zm0,5.64a1.692,1.692,0,1,0,1.692,1.692,1.692,1.692,0,0,0-1.692-1.692Zm15.791.564H6.2a.564.564,0,0,0-.564.564V16.91a.564.564,0,0,0,.564.564H17.483a.564.564,0,0,0,.564-.564V15.782A.564.564,0,0,0,17.483,15.218Zm0-11.279H6.2A.564.564,0,0,0,5.64,4.5V5.631a.564.564,0,0,0,.564.564H17.483a.564.564,0,0,0,.564-.564V4.5A.564.564,0,0,0,17.483,3.939Zm0,5.64H6.2a.564.564,0,0,0-.564.564V11.27a.564.564,0,0,0,.564.564H17.483a.564.564,0,0,0,.564-.564V10.142A.564.564,0,0,0,17.483,9.579Z",
    transform: "translate(0 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListwhite);
export default __webpack_public_path__ + "static/media/listwhite.1bdb134d8ebf751e4f23968828c86c9a.svg";
export { ForwardRef as ReactComponent };